export default __webpack_public_path__ + "static/media/Cotton.a37bb9e0.jpg";